import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function DusKaDum() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "dum10";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Dus ka Dum"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container duskadum"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            Dus ka Dum
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span> */}
      {/* <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>152250425211849</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>152250425211849</span>
            </span>
          </div>
        </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/dum10/5af03541-872a-497a-91e7-7f49dcf4c087?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
              <div className="dkd-total mb-1 mt-1">
                <div>
                  <div>
                    <div>Curr. Total:</div>
                    <div className="numeric text-playerb">117</div>
                  </div>
                  <div>Card #: 16</div>
                </div>
                <div>Next Total 120 or More</div>
              </div>
              <div className="ab-cards-container">
                <div className="ms-4">
                  {/* <div className="slick-slider slick-initialized" dir="ltr">
                    <button
                      type="button"
                      data-role="none"
                      className="slick-arrow slick-prev"
                      style={{ display: "block" }}
                    >
                      {" "}
                      Previous
                    </button>
                    <div className="slick-list">
                      <div
                        className="slick-track"
                        style={{
                          width: 704,
                          opacity: 1,
                          transform: "translate3d(-572px, 0px, 0px)"
                        }}
                      >
                        <div
                          data-index={15}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9SS.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={14}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/QSS.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={13}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/6HH.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={12}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9CC.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={11}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/JCC.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={10}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/KCC.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={9}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/10DD.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={8}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/5CC.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={7}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/8DD.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={6}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4SS.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={5}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/KHH.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={4}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/AHH.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={3}
                          className="slick-slide"
                          tabIndex={-1}
                          aria-hidden="true"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/ASS.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={2}
                          className="slick-slide slick-active"
                          tabIndex={-1}
                          aria-hidden="false"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/QDD.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={1}
                          className="slick-slide slick-active"
                          tabIndex={-1}
                          aria-hidden="false"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/2CC.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                        <div
                          data-index={0}
                          className="slick-slide slick-active slick-current"
                          tabIndex={-1}
                          aria-hidden="false"
                          style={{ outline: "none", width: 44 }}
                        >
                          <div>
                            <img
                              src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/ADD.jpg"
                              tabIndex={-1}
                              style={{ width: "100%", display: "inline-block" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      data-role="none"
                      className="slick-arrow slick-next slick-disabled"
                      style={{ display: "block" }}
                    >
                      {" "}
                      Next
                    </button>
                  </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </div>  */}
      {/* <div className="casino-video-current-card">
              <div className="flip-card">
                <div className="flip-card-inner ">
                 
                  <div className="flip-card-back">
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                  </div>
                </div>
              </div>
            </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-header">
              <div className="casino-nation-detail" />
              <div className="casino-odds-box back">Back</div>
              <div className="casino-odds-box lay">Lay</div>
            </div>
            <div className="casino-table-body">
              <div className="casino-table-row ">
                <div className="casino-nation-detail">
                  <div className="casino-nation-name">
                    {/* Next Total 120 or More */}
                    {
                      casinoData?.data?.response?.oddDetailsDTOS?.[0]
                        ?.runnerName
                    }
                  </div>
                  <div />
                </div>
                {/* <div className="casino-odds-box back"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  //   onClick={() =>
                  //     setBet(
                  //       "Next Total 90 or More",
                  //       casinoData,
                  //       dispatch,
                  //       "back"
                  //     )
                  //   }
                  // >
                  onClick={() =>
                    setBet(
                      casinoData?.data?.response?.oddDetailsDTOS?.[0]
                        ?.runnerName,
                      casinoData,
                      dispatch,
                      "back"
                    )
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity(
                      casinoData?.data?.response?.oddDetailsDTOS?.[0]
                        ?.runnerName,
                      casinoData,
                      true
                    )}
                  </span>
                </div>
                {/* <div className="casino-odds-box lay"> */}
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet(
                      casinoData?.data?.response?.oddDetailsDTOS?.[0]
                        ?.runnerName,
                      casinoData,
                      dispatch,
                      "lay"
                    )
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity(
                      casinoData?.data?.response?.oddDetailsDTOS?.[0]
                        ?.runnerName,
                      casinoData,
                      false
                    )}
                  </span>
                </div>
              </div>
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.oddDetailsDTOS?.[0]?.runnerName"
                )}
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3">
            <div className="casino-table-left-box">
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {" "}
                  {getOddForEntity("Even", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Even", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">Even</span>
                </div>
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Even")}
                </div>
              </div>
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {" "}
                  {getOddForEntity("Odd", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Odd", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">Odd</span>
                </div>
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Odd")}
                </div>
              </div>
            </div>
            <div className="casino-table-right-box">
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Red", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Red", casinoData, dispatch, "back")}
                >
                  <div className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-red ">{"{"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-red ">[</span>
                    </span>
                  </div>
                </div>
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Red")}
                </div>
              </div>
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Black", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Black", casinoData, dispatch, "back")}
                >
                  <div className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-black ">{"}"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-black ">]</span>
                    </span>
                  </div>
                </div>
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Black")}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/dum10">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">N</span>
              <span className="result result-b">N</span>
              <span className="result result-a">Y</span>
              <span className="result result-b">N</span>
              <span className="result result-b">N</span>
              <span className="result result-a">Y</span>
              <span className="result result-b">N</span>
              <span className="result result-a">Y</span>
              <span className="result result-b">N</span>
              <span className="result result-a">Y</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
